import { useState, useEffect, useCallback } from 'react';

/* Room / ambience / drop chosen in the configurator preview — shared by every preview instance
   and remembered across visits (localStorage) so switching colours never resets the scene or lighting. */
const KEY = 'apollo_cfg_preview_prefs';
const DEFAULTS = { roomId: 'living', ambience: 'day', drop: 1 };

const load = () => {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || '{}') }; } catch { return { ...DEFAULTS }; }
};

let state = load();
const subscribers = new Set();

const publish = () => {
  try { localStorage.setItem(KEY, JSON.stringify(state)); } catch { /* storage unavailable */ }
  subscribers.forEach(fn => fn(state));
};

export const resetPreviewPrefs = () => { state = { ...DEFAULTS }; publish(); };

export const usePreviewPrefs = () => {
  const [prefs, setPrefs] = useState(state);
  useEffect(() => { subscribers.add(setPrefs); return () => subscribers.delete(setPrefs); }, []);
  const update = useCallback((patch) => { state = { ...state, ...patch }; publish(); }, []);
  return [prefs, update];
};
